import Markdown from "react-markdown";
import { Link } from "react-router";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import * as Paths from "../paths";
import type { Route } from "./+types/privacy-policy";
import privacyPolicyMarkdown from "../../static/privacy-policy.md?raw";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function loader(_args: Route.LoaderArgs) {
  return { markdown: privacyPolicyMarkdown };
}

export default function PrivacyPolicy({ loaderData }: Route.ComponentProps) {
  return (
    <div className="flex min-h-screen flex-col w-full bg-white">
      <div className="w-full">
        <header className="sticky w-full top-0 z-50 border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60 py-4">
          <div className="container flex items-center justify-between mx-auto">
            <div className="flex items-center">
              <Link to={Paths.index()}>
                <img
                  src="/assets/logo.svg"
                  alt="AnyLawyer Logo"
                  className="w-[140px]"
                />
              </Link>
            </div>
          </div>
        </header>
        <main className="flex-1">
          <div className="container mx-auto px-4 py-12 max-w-4xl">
            <div className="prose prose-lg max-w-none">
              <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                {loaderData.markdown}
              </Markdown>
            </div>
          </div>
        </main>
        <footer className="bg-gray-50 py-12 border-t">
          <div className="container mx-auto px-4">
            <div className="grid gap-8 md:grid-cols-2">
              <div>
                <div className="flex items-center gap-2 mb-4">
                  <img
                    src="/assets/logo.svg"
                    alt="AnyLawyer Logo"
                    className="w-[140px]"
                  />
                </div>
                <p className="text-gray-600 text-sm max-w-xs">
                  AI-powered document intelligence for legal professionals.
                  Transform how you analyze, search, and extract insights from
                  legal documents.
                </p>
              </div>
              <div>
                <h3 className="font-semibold mb-4">Legal</h3>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li>
                    <Link
                      to={Paths.privacyPolicy()}
                      className="hover:text-primary transition-colors"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={Paths.termsOfService()}
                      className="hover:text-primary transition-colors"
                    >
                      Terms of Service
                    </Link>
                  </li>
                </ul>
                <div className="mt-6">
                  <h3 className="font-semibold mb-2">Contact Us</h3>
                  <Link
                    to="mailto:hello@anylawyer.com"
                    className="text-sm text-primary hover:underline"
                  >
                    hello@anylawyer.com
                  </Link>
                </div>
              </div>
            </div>
            <div className="mt-12 pt-8 text-center">
              <p className="text-sm text-gray-600">
                © 2025 AnyLawyer. All rights reserved.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
